// Section 9 and 15: Cemetery. 4 build points, 4 stone; grief duration halved; each death costs
// settlement happiness -1 instead of -3 (both applied where deaths are recorded,
// phases/shared/death.ts, via `hasBuilding`). Limit 1. Constants: config.buildings.cemetery.
import type { Config } from '../../config';
import { buildingEffectHook, noDeltas } from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function cemetery(config: Config) {
  const c = config.buildings.cemetery;

  return defineBuilding({
    id: 'cemetery',
    label: 'Cemetery',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { stone: c.stone },
    material: 'stone',
    beds: 0,
    plots: 0,
    capacity: {},
    limit: { kind: 'fixed', max: c.limit },
    modifierTargets: ['buildingEffect'],
    modifiers: buildingEffectHook('cemetery'),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
